export default __webpack_public_path__ + "static/media/BasisGrotesquePro-Medium.8d21314b.woff";